import { createAsyncThunk } from '@reduxjs/toolkit';
import type {
  CreateWorkspaceCredentialInput,
  UpdateWorkspaceCredentialInput,
  WorkspaceCredential,
} from '../../types/workspaceCredentials';
import { workspaceCredentialsService } from './services';

export const fetchWorkspaceCredentials = createAsyncThunk<
  WorkspaceCredential[],
  { escritorioId: string; search?: string },
  { rejectValue: string }
>('workspaceCredentials/fetch', async ({ escritorioId, search }, { rejectWithValue }) => {
  try {
    return await workspaceCredentialsService.list(escritorioId, search);
  } catch (error) {
    return rejectWithValue(error instanceof Error ? error.message : 'Erro ao carregar credenciais');
  }
});

export const createWorkspaceCredential = createAsyncThunk<
  WorkspaceCredential,
  CreateWorkspaceCredentialInput,
  { rejectValue: string }
>('workspaceCredentials/create', async (data, { rejectWithValue }) => {
  try {
    return await workspaceCredentialsService.create(data);
  } catch (error) {
    return rejectWithValue(error instanceof Error ? error.message : 'Erro ao criar credencial');
  }
});

export const updateWorkspaceCredential = createAsyncThunk<
  WorkspaceCredential,
  { id: string; data: UpdateWorkspaceCredentialInput },
  { rejectValue: string }
>('workspaceCredentials/update', async ({ id, data }, { rejectWithValue }) => {
  try {
    return await workspaceCredentialsService.update(id, data);
  } catch (error) {
    return rejectWithValue(error instanceof Error ? error.message : 'Erro ao atualizar credencial');
  }
});

export const deleteWorkspaceCredential = createAsyncThunk<string, string, { rejectValue: string }>(
  'workspaceCredentials/delete',
  async (id, { rejectWithValue }) => {
    try {
      await workspaceCredentialsService.remove(id);
      return id;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Erro ao excluir credencial');
    }
  },
);
